module.exports = __webpack_public_path__ + "img/btn_treatmentConsiderations.9e423219.png";